import type { CentrixSchemas } from "core/entities/APITypes";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export type SuggestionStatus =
  CentrixSchemas["Fixhub.Suggestions.SuggestionStatus"];
export type SuggestionDetailDto =
  CentrixSchemas["Fixhub.Suggestions.SuggestionDetailDto"];
export type SuggestionDto = CentrixSchemas["Fixhub.Suggestions.SuggestionDto"];

export const STATUS_COLORS: Record<
  SuggestionStatus,
  "default" | "info" | "success" | "error" | "warning"
> = {
  New: "default",
  UnderReview: "info",
  Approved: "success",
  Rejected: "error",
  Invalid: "warning",
};

export const REQUEST_TYPE_OPTIONS = [
  { key: "improvement", defaultLabel: "Improvement Suggestion" },
  { key: "newFeature", defaultLabel: "New Feature Request" },
  { key: "bug", defaultLabel: "Problem / Bug Report" },
  { key: "other", defaultLabel: "Other" },
] as const;

export function useRequestTypeFormatter() {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:SuggestionBoxDialog",
  });
  return useCallback(
    (requestType: string) => {
      const option = REQUEST_TYPE_OPTIONS.find(
        (opt) => opt.key === requestType
      );
      return option
        ? t(`requestTypeOptions.${option.key}`, option.defaultLabel)
        : requestType;
    },
    [t]
  );
}
